import React from 'react'
import bgImage from '../../assets/servicesImages/allindustrymanufacturingerps/hero.png'
import icon1 from '../../assets/servicesImages/allindustrymanufacturingerps/icon1.png'
import icon2 from '../../assets/servicesImages/allindustrymanufacturingerps/icon2.png'
import icon3 from '../../assets/servicesImages/allindustrymanufacturingerps/icon3.png'
import icon4 from '../../assets/servicesImages/allindustrymanufacturingerps/icon4.png'
import icona from '../../assets/servicesImages/allindustrymanufacturingerps/icona.png'
import iconb from '../../assets/servicesImages/allindustrymanufacturingerps/iconb.png'
import iconc from '../../assets/servicesImages/allindustrymanufacturingerps/iconc.png'
import icond from '../../assets/servicesImages/allindustrymanufacturingerps/icond.png'
import icone from '../../assets/servicesImages/allindustrymanufacturingerps/icone.png'
import iconf from '../../assets/servicesImages/allindustrymanufacturingerps/iconf.png'
import icong from '../../assets/servicesImages/allindustrymanufacturingerps/icong.png'
import Slider from 'react-slick'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const items = [
    {
        icon: icona,
        title: 'Sales & Purchase Management',
        desc: 'Increase Productivity & Lower Costs By Managing Your Sales & Purchased. It Manages complete cycle from Purchases to Sales Order.'
    },
    {
        icon: iconb,
        title: 'Inventory Management',
        desc: 'Systematically Manages the sourcing, storing, and selling inventory—both raw materials (components) and finished goods (products).'
    },
    {
        icon: iconc,
        title: 'Project Management',
        desc: 'Help in Delivered Projects on Time with great Profits in Projects . It manages tasks status, Timesheet and project work on time.'
    },
    {
        icon: icond,
        title: 'Financial Management',
        desc: 'Manages all Financial transaction so real time view of Cash flow. It covers all features required for Accounting.'
    },
    {
        icon: icone,
        title: 'Document Management',
        desc: 'Help in Maintain All Document required for Organization with some standard Template.'
    },
    {
        icon: iconf,
        title: 'Workorder Management',
        desc: 'Systematic approach of processing and completing maintenance work orders in a timely manner.'
    },
    {
        icon: icong,
        title: 'Manufacturing',
        desc: 'Our software development team is exceptionally skilled in planning the deployment and maintenance of complex software systems.'
    }
];

const settings = {
    className: "center",
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 3,
    centerMode: true,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                centerMode: false
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                centerMode: false
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                centerMode: false
            }
        }
    ]
};

const cards = [
    {
        icon: icon1,
        title: 'Availability',
        desc: 'Automate business processes, so businesses can increase production efficiency, save costs & maximize profits.'
    },
    {
        icon: icon2,
        title: 'Promises',
        desc: 'Act on insights, improve performance and share results with reporting.'
    },
    {
        icon: icon3,
        title: 'Creativity',
        desc: 'All The data are highly secured on cloud.'
    },
    {
        icon: icon4,
        title: 'Determination',
        desc: 'Improves the decision-making ability of an organization.'
    },
];

const AllIndustryERP = () => {
    return (
        <div className='flex flex-col gap-[64px]'>
            {/* Hero Section */}
            <div
  className="w-full text-white flex justify-start items-center pt-24 relative bg-cover bg-center 
    sm:min-h-[400px] md:min-h-[500px] lg:min-h-[600px]"
                style={{ backgroundImage: `url(${bgImage})` }}>
                <div className="absolute inset-0 bg-[rgba(0, 0, 0, 0.4)] z-0"></div>
                <div className='flex flex-col gap-[48px] p-8 sm:p-16 md:p-24 z-10'>
                    <div className='flex flex-col w-full sm:w-[350px] md:w-[470px] gap-[32px]'>
                        <p className='font-nunito text-[20px] sm:text-[20px] md:text-[48px] font-bold md:leading-[45px] lg:leading-[45px] sm:leading-[20px] text-left'>
                            For all Industry Manufacturing ERP
                        </p>
                        <p className="text-[16px] sm:text-[18px] font-normal leading-[25.6px] text-left">
                            The only platform you will ever need to help run your business.
                        </p>
                    </div>
                </div>
            </div>

            {/* What is ERP Section */}
            <div className='flex flex-col gap-[36px] px-6 sm:px-12 md:px-24 lg:px-60'>
                <p className='text-center text-[24px] sm:text-[28px] md:text-[32px] font-semibold leading-[23.4px]'>
                    What is Sparse Manufacturing ERP?
                </p>
                <p className='font-nunito text-[14px] sm:text-[16px] font-medium leading-[28.6px] text-justify'>
                    Sparse Manufacturing ERP is a system that manages a manufacturing company’s processes, such as Sales & Purchase, Production Process, Inventory, HR Activities, Accounting, and more.
                    Using Sparse Manufacturing ERP, all these processes integrate into one single system to provide real-time data and information across departments, boosting efficiency, cutting costs, and maximizing profits.
                </p>
            </div>

            {/* Benefits Section */}
            <div className='flex flex-col gap-[28px] px-4 sm:px-8 md:px-24'>
                <div className='flex flex-col gap-[36px]'>
                    <p className='text-center text-[24px] sm:text-[28px] md:text-[32px] font-semibold leading-[34px]'>
                        What are the Benefits of Sparse Manufacturing ERP?
                    </p>
                    <p className='font-nunito text-[14px] sm:text-[16px] font-medium leading-[25.6px] text-center'>
                        Sparse Manufacturing ERP is a system that manages a manufacturing company’s processes.
                    </p>
                </div>

                <div className='flex justify-center items-center gap-6 flex-wrap'>
  {cards.map((c, index) => (
    <div key={index} className='w-full sm:w-[48%] md:w-[267px] lg:w-[267px]'>
      <div className='w-full h-[296px] bg-white shadow-xl flex flex-col items-center py-10 px-6 gap-[10px] rounded-lg transition-all duration-300 group hover:shadow-2xl hover:scale-[1.03]'>
        <div className='flex justify-center'>
          <img
            src={c.icon}
            alt={c.title}
            className='w-[60.33px] h-[59.49px] mb-4 transition-transform duration-300 group-hover:scale-110'
          />
        </div>
        <p className='text-[#3C4858] text-center font-bold text-[20px] group-hover:text-blue-800 transition-colors duration-300'>
          {c.title}
        </p>
        <p className='text-[#161C2D] text-center text-[16px] leading-[24px] px-2'>
          {c.desc}
        </p>
      </div>
    </div>
  ))}
</div>

            </div>

            {/* Modules Section */}
            <p className='text-[28px] sm:text-[30px] md:text-[32px] font-semibold leading-[23.4px] text-center'>
                Our Modules
            </p>

            <div className='bg-[#EAEEFB] py-10 flex flex-col justify-center mb-20'>
  <div className='w-full px-4 sm:px-8 md:px-16'>
    <Slider {...settings}>
      {items.map((item, index) => (
        <div key={index} className='group'>
          <div className='w-full sm:w-[304px] h-[404px] mx-auto py-[24px] px-[18px] flex flex-col items-center bg-white gap-[8px] shadow-xl rounded-lg transition-all duration-300 group-hover:scale-[1.03] group-hover:shadow-2xl'>
            <div className='h-[90%] flex flex-col items-center gap-[10px]'>
              <img
                src={item.icon}
                alt={item.title}
                className='w-[60.33px] h-[59.49px] transition-transform duration-300 group-hover:scale-110'
              />
              <p className='text-[#3C4858] text-center font-bold text-[20px] group-hover:text-blue-800 transition-colors duration-300'>
                {item.title}
              </p>
              <p className='text-[#161C2D] text-center text-[16px] leading-[24px] px-3'>
                {item.desc}
              </p>
            </div>
            <button className='bg-[#006BD3] w-[112px] mb-3 p-[8px_12px] rounded text-white transition-transform duration-300 group-hover:scale-105'>
              Read More
            </button>
          </div>
        </div>
      ))}
    </Slider>
  </div>
</div>

        </div>
    )
}

export default AllIndustryERP;
